var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "@emotion/styled";
export var TitleContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\n\th6 {\n\t\tflex-grow: 1;\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\tmargin: 0;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\n\th6 {\n\t\tflex-grow: 1;\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\tmargin: 0;\n\t}\n"])));
var templateObject_1;
